// Action Types
export const FETCH_HCPCS_REQUEST = 'FETCH_HCPCS_REQUEST';
export const FETCH_HCPCS_SUCCESS = 'FETCH_HCPCS_SUCCESS';
export const FETCH_HCPCS_FAILURE = 'FETCH_HCPCS_FAILURE';

export const CREATE_HCPC_REQUEST = 'CREATE_HCPC_REQUEST';
export const CREATE_HCPC_SUCCESS = 'CREATE_HCPC_SUCCESS';
export const CREATE_HCPC_FAILURE = 'CREATE_HCPC_FAILURE';

export const UPDATE_HCPC_REQUEST = 'UPDATE_HCPC_REQUEST';
export const UPDATE_HCPC_SUCCESS = 'UPDATE_HCPC_SUCCESS';
export const UPDATE_HCPC_FAILURE = 'UPDATE_HCPC_FAILURE';

export const DELETE_HCPC_REQUEST = 'DELETE_HCPC_REQUEST';
export const DELETE_HCPC_SUCCESS = 'DELETE_HCPC_SUCCESS';
export const DELETE_HCPC_FAILURE = 'DELETE_HCPC_FAILURE';

export const FETCH_HCPC_RULES_REQUEST = 'FETCH_HCPC_RULES_REQUEST';
export const FETCH_HCPC_RULES_SUCCESS = 'FETCH_HCPC_RULES_SUCCESS';
export const FETCH_HCPC_RULES_FAILURE = 'FETCH_HCPC_RULES_FAILURE';

export const MAP_HCPC_TO_RULE_REQUEST = 'MAP_HCPC_TO_RULE_REQUEST';
export const MAP_HCPC_TO_RULE_SUCCESS = 'MAP_HCPC_TO_RULE_SUCCESS';
export const MAP_HCPC_TO_RULE_FAILURE = 'MAP_HCPC_TO_RULE_FAILURE';

export const DELETE_HCPC_RULE_MAPPING_REQUEST = 'DELETE_HCPC_RULE_MAPPING_REQUEST';
export const DELETE_HCPC_RULE_MAPPING_SUCCESS = 'DELETE_HCPC_RULE_MAPPING_SUCCESS';
export const DELETE_HCPC_RULE_MAPPING_FAILURE = 'DELETE_HCPC_RULE_MAPPING_FAILURE';

// Action Creators
export const fetchHcpcsRequest = ( options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_HCPCS_REQUEST,
        payload: { page, limit, search },
        
      }; 
    }; 
export const fetchHcpcsSuccess = (hcpcs) => ({ type: FETCH_HCPCS_SUCCESS, payload: hcpcs });
export const fetchHcpcsFailure = (error) => ({ type: FETCH_HCPCS_FAILURE, payload: error });

export const createHcpcRequest = (data) => ({ type: CREATE_HCPC_REQUEST, payload: data });
export const createHcpcSuccess = (hcpc) => ({ type: CREATE_HCPC_SUCCESS, payload: hcpc });
export const createHcpcFailure = (error) => ({ type: CREATE_HCPC_FAILURE, payload: error });

export const updateHcpcRequest = (id, data) => ({ type: UPDATE_HCPC_REQUEST, payload: { id, data } });
export const updateHcpcSuccess = (hcpc) => ({ type: UPDATE_HCPC_SUCCESS, payload: hcpc });
export const updateHcpcFailure = (error) => ({ type: UPDATE_HCPC_FAILURE, payload: error });

export const deleteHcpcRequest = (id) => ({ type: DELETE_HCPC_REQUEST, payload: id });
export const deleteHcpcSuccess = (id) => ({ type: DELETE_HCPC_SUCCESS, payload: id });
export const deleteHcpcFailure = (error) => ({ type: DELETE_HCPC_FAILURE, payload: error });

export const fetchHcpcRulesRequest = (projectId, hcpcId) => ({ type: FETCH_HCPC_RULES_REQUEST, payload: { projectId, hcpcId } });
export const fetchHcpcRulesSuccess = (rules) => ({ type: FETCH_HCPC_RULES_SUCCESS, payload: rules });
export const fetchHcpcRulesFailure = (error) => ({ type: FETCH_HCPC_RULES_FAILURE, payload: error });

export const mapHcpcToRuleRequest = (projectId, hcpcId, ruleId) => ({ type: MAP_HCPC_TO_RULE_REQUEST, payload: { projectId, hcpcId, ruleId } });
export const mapHcpcToRuleSuccess = () => ({ type: MAP_HCPC_TO_RULE_SUCCESS });
export const mapHcpcToRuleFailure = (error) => ({ type: MAP_HCPC_TO_RULE_FAILURE, payload: error });

export const deleteHcpcRuleMappingRequest = (projectId, hcpcId, ruleId) => ({ type: DELETE_HCPC_RULE_MAPPING_REQUEST, payload: { projectId, hcpcId, ruleId } });
export const deleteHcpcRuleMappingSuccess = () => ({ type: DELETE_HCPC_RULE_MAPPING_SUCCESS });
export const deleteHcpcRuleMappingFailure = (error) => ({ type: DELETE_HCPC_RULE_MAPPING_FAILURE, payload: error });
